import {Box} from "@mui/material";
import MyCoursesList from "../components/MyCoursesList";

const MyCoursesPage = () => {
    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <MyCoursesList />
        </Box>
    );
};
export default MyCoursesPage;
